// src/features/dataSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// Async thunk to fetch data from API
export const resetPassword = createAsyncThunk(
  "resetpassword",
  async ({ id, values }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/reset-password/${id}`,
        values,
      );
      return response.data;
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  },
);

const resetPasswordSlice = createSlice({
  name: "reset",
  initialState: {
    reset: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.resetPassword = action.payload;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action;
      });
  },
});

export default resetPasswordSlice.reducer;
